<div class="speech-box" [ngClass]="{'speech-box-user': chatEntity.author === author.user, 'speech-box-eva': chatEntity.author === author.eva}">
    <div [innerHtml]="chatEntity.text | safeHtml"></div>
    <div class="speech-box-originator" *ngIf="chatEntity.originator">From {{ chatEntity.originator }}</div>
</div>
